import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();

function fadeOutEffect() {
    var fadeTarget = document.getElementById("cookie-banner");
    var fadeEffect = setInterval(function () {
        if (!fadeTarget.style.opacity) {
            fadeTarget.style.opacity = 1;
        }
        if (fadeTarget.style.opacity > 0) {
            fadeTarget.style.opacity -= 0.1;
        } else {
            clearInterval(fadeEffect);
        }
    }, 200);
}

if (localStorage.getItem("cookieSeen") !== "shown") {
    localStorage.setItem("cookieSeen","shown")
};

/* document.getElementById(".close").click(function() {
    document.getElementById(".cookie-banner").fadeOutEffect();
})*/



// WEBPACK FOOTER //
// ./src/index.js